export const MeetingsData = [
    {
        id: 1,
        key: "id",
        si_no: "",
        select: "",
        customer_name: "Darlee Robertson",
        image: "assets/img/profiles/profile-img.jpg",
        customer_no: "Facility Manager",
        phone: "1234567890",
        email: "robertson@example.com",
        location: 'USA',
        department: "Client",
        created: "25 Sep 2023, 12:12 pm",
        last_activity: "2 mins ago",
        status: "Upcoming",
        priority: "Low",
    },
    {
        id: 2,
        key: 2,
        si_no: "",
        select: "",
        customer_name: "Sharon Roy",
        image: "assets/img/profiles/profile-img.jpg",
        customer_no: "Installer",
        phone: "+1 989757485",
        email: "sharon@example.com",
        location: 'USA',
        department: "Finance Department",
        created: "27 Sep 2023, 07:40 am",
        last_activity: "5 mins ago",
        status: "Canceled",
        priority: "High",
    },
    {
        id: 3,
        key: 3,
        si_no: "",
        select: "",
        customer_name: "Vaughan",
        image: "assets/img/profiles/profile-img.jpg",
        customer_no: "Senior  Manager",
        phone: "+1 546555455",
        email: "vaughan12@example.com",
        location: 'USA',
        department: "Sales Department",
        created: "29 Sep 2023, 08:20 am",
        last_activity: "2 days ago",
        status: "Completed",
        priority: "Medium",
    },
    {
        id: 4,
        key: 4,
        si_no: "",
        select: "",
        customer_name: "Jessica",
        image: "assets/img/profiles/profile-img.jpg",
        customer_no: "Test Engineer",
        phone: "+1 454478787",
        email: "jessica13@example.com",
        location: 'USA',
        department: "Sales Department",
        created: "25 Sep 2023, 12:12 pm",
        last_activity: "2 mins ago",
        status: "Upcoming",
        priority: "Low",
    },
    {
        id: 5,
        key: 5,
        si_no: "",
        select: "",
        customer_name: "Carol Thomas",
        image: "assets/img/profiles/profile-img.jpg",
        customer_no: "UI /UX Designer",
        phone: "+1 124547845",
        email: "caroltho3@example.com",
        location: 'USA',
        department: "Sales Department",
        created: "02 Oct 2023, 10:10 am",
        last_activity: "Online",
        status: "Completed",
        priority: "Medium",
    },
];
